import script from "./generate.vue?vue&type=script&setup=true&lang=js"
export * from "./generate.vue?vue&type=script&setup=true&lang=js"

import "./generate.vue?vue&type=style&index=0&id=bbeb0258&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbeb0258"]])

export default __exports__